import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { handleDatePickerShortcuts } from "../../../utils/keyboardShortcutHelpers";
import StyledDatePicker from "../StyledDatePicker/StyledDatePicker";
import StyledFormHelperText from "../StyledFormHelperText/StyledFormHelperText";

export default function PrimaryDatePicker({
  label,
  value,
  handleChange,
  width,
  disablePast,
  error,
  onEnter,
  disabled,
  helperText
}) {
  const [pressedKeys, setPressedKeys] = useState({});

  const handleKeyDown = useCallback((event) => {
    if (event.key === "Enter" && onEnter) {
      onEnter();
      return;
    } 

    handleDatePickerShortcuts(event, pressedKeys, setPressedKeys, value, handleChange);

  }, [value]);

  const handleKeyUp = useCallback((event) => {
    const keys = pressedKeys;
    delete keys[event.key];

    setPressedKeys(keys);
  }, []);

  return (
    <Box sx={{ display: "inline" }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <StyledDatePicker
          label={label}
          value={value}
          disablePast={disablePast}
          onChange={handleChange}
          sx={{ width: width }}
          disabled={disabled}
          slotProps={{
            textField: { 
              size: "small",
              onKeyDown: handleKeyDown, 
              onKeyUp: handleKeyUp,
              error: error,
            },
            popper: {
              sx: { boxShadow: "elevation1" },
            }
          }}
        />
      </LocalizationProvider>
      <StyledFormHelperText error={error} disabled={disabled}>{helperText}</StyledFormHelperText>
    </Box>
  );
}

PrimaryDatePicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  handleChange: PropTypes.func.isRequired,
  width: PropTypes.string,
  disablePast: PropTypes.bool,
  error: PropTypes.bool,
  onEnter: PropTypes.func,
  disabled: PropTypes.bool,
  helperText: PropTypes.string
};